import React from "react";
import { useNavigate } from "react-router-dom/dist";
import { FundraiserSubsequentInfo } from "../../Interfaces/Fundraiser";
import { encodeQueryParameter } from "../../CommonFunctions";

type EditParticipantsProps = {
  fundraiserID: number;
};

const EditParticipantsButton: React.FC<EditParticipantsProps> = ({
  fundraiserID,
}) => {
  const navigate = useNavigate();
  const handleClick = () => {
    const encodedFundraiser = encodeQueryParameter({
      fundraiserID: fundraiserID.toString(),
    });
    navigate(`/fundraiser/edit-participants/${encodedFundraiser}`);
  };

  const buttonStyle: React.CSSProperties = {
    padding: "10px 20px",
    backgroundColor: "#193288",
    color: "white",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    fontSize: "16px",
    minHeight: "50px",
    flexGrow: 2, // Makes it expand inside a flex container
    width: "75%",
  };

  return (
    <button onClick={handleClick} style={buttonStyle}>
      Edit Participants
    </button>
  );
};

export default EditParticipantsButton;
